import BackendService from './BackendService';
import CacheHelper from 'helpers/CacheHelper';

const cache = {};

let shopsPromise = null;

async function getShops() {
  const cachedShops = CacheHelper.get(cache, 'shops');
  if (cachedShops) {
    return cachedShops;
  }

  if (shopsPromise) {
    return shopsPromise;
  }

  shopsPromise = BackendService.getData('/shops/');
  try {
    const shops = await shopsPromise;
    CacheHelper.store(cache, 'shops', shops);
    return shops;
  } catch (error) {
    console.error('Failed to fetch shops:', error);
    throw error;
  } finally {
    shopsPromise = null;
  }
}

async function requestShopDeletion(id) {
  const resp = await BackendService.destroy(`/shops/${id}/`);
  CacheHelper.clear(cache, 'shops');
  return resp;
}

async function cancelDeletion() {
  try {
    const response = await BackendService.destroy(`/shop-delete-schedule/`);
    CacheHelper.clear(cache, 'shops');
    return response;
  } catch (error) {
    console.error('Cancel deletion failed:', error);
    return { error: 'Failed to cancel deletion. Please try again later.' };
  }
}

async function getDeletionStatus() {
  return BackendService.getData(`/shop-delete-schedule/`);
}

const ShopService = {
  getShops,
  requestShopDeletion,
  cancelDeletion,
  getDeletionStatus,
};

export default ShopService;
